<template>
  <div>
    <Header :logo="logo" :top="top"></Header>
    <router-view></router-view>
    <Footer :config="config" :foot="foot" :newsCate="newsCate"></Footer>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import service from "@/assets/js/service";

export default {
  data() {
    return {
      logo: "",
      config: {},
      foot: {},
      top: { news_cats: [] },
      newsCate: {},
    };
  },
  methods: {
    async common() {
      let res = await service.common();
      if (res.code == 1) {
        this.logo = res.data.config.logo;
        this.config = res.data.config;
        this.foot = res.data.foot;
        this.top = res.data.top;
        this.newsCate = res.data.top.news_cats;
      }
    },

    async ipregion() {
      if (localStorage.setItem("ip")) return;

      const res = await service.ipregion();
      localStorage.setItem("ip", res);
      if (process.env.NODE_ENV === "production" && res == "CN") location.href = "http://hmagvs.com";
    }
  },
  created() {
    this.common();
    this.ipregion();
  },
  components: { Header, Footer },
};
</script>

<style lang="less">
@import url(./assets/font/iconfont.css);
@import url(./assets/css/animate.min.css);

@font-face {
  font-family: Regular;
  src: url(./assets/font/Alibaba-PuHuiTi-Regular.otf);
}

* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100vw;
  overflow-x: hidden;
}

body {
  -webkit-font-smoothing: antialiased;
  font: 15px/1.5 Regular, Microsoft YaHei, Heiti SC, tahoma, arial,
    Hiragino Sans GB, "\5B8B\4F53", sans-serif;
  color: #333;
}

em,
i {
  font-style: normal;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
}

img {
  border: 0;
  vertical-align: middle;
}

p {
  line-height: 2;
}

textarea,
select,
button,
input {
  font-family: Regular, Microsoft YaHei, Heiti SC, tahoma, arial,
    Hiragino Sans GB, "\5B8B\4F53", sans-serif;
  border: none;
  outline: none;
  background: none;
  resize: none;
  outline: none;
  border-radius: 10px;
  transition: all 0.3s;

  /* chrome */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  /* 火狐浏览器 */
  &[type="number"] {
    -moz-appearance: textfield;
  }
}

.dh_text {
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;

  display: -webkit-box;
  display: -moz-box;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal !important;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.dh_text2 {
  display: -webkit-box;
  display: -moz-box;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal !important;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.dh_text3 {
  display: -webkit-box;
  display: -moz-box;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal !important;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.dh_text4 {
  display: -webkit-box;
  display: -moz-box;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal !important;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

:root {
  --themeColor: #004998;
  --themeColor2: #ffa500;
  --container: 1400px;
  --containerLeft: calc((100vw - var(--container)) / 2);
}

.container {
  width: var(--container);
  margin: 0 auto;
}

@keyframes op {

  0%,
  100% {
    opacity: 0.2;
  }

  50% {
    opacity: 1;
  }
}

.more {
  z-index: 2;
  width: max-content;
  color: #fff;
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  font-family: Regular !important;
  font-size: 14px;
  margin-left: 10px;

  &::before {
    font-family: iconfont !important;
    margin-left: 20px;
    font-size: 12px;
  }

  &::after {
    content: "";
    display: block;
    background: var(--themeColor2);
    width: 1.5em;
    height: 1.5em;
    position: absolute;
    z-index: -1;
    border-radius: 50%;
    left: -10px;
    transition: all 0.3s;
  }

  @media (min-width: 850px) {
    &:hover::after {
      left: calc(100% - 17px);
    }
  }

  &.b {
    color: #333;
  }
}

section,
section.container {
  margin: 110px auto;
}

/* 富文本渲染 */
.rich {

  img,
  video {
    max-width: 100% !important;
    height: auto !important;
  }

  &,
  * {
    font-family: Regular !important;
  }
}

@media (max-width: 1450px) {
  :root {
    --container: 1200px;
  }

  section,
  section.container {
    margin: 90px auto;
  }
}

@media (max-width: 1250px) {
  :root {
    --container: 1000px;
  }

  section,
  section.container {
    margin: 70px auto;
  }
}

@media (max-width: 1000px) {
  :root {
    --container: 92vw;
  }

  section,
  section.container {
    margin: 50px auto;
  }
}

@media (max-width: 700px) {

  section,
  section.container {
    margin: 40px auto;
  }
}
</style>
